import { toast } from '@/shared/toast'

export const copyToClipboard = (title: string, content: string) => {
  navigator.clipboard.writeText(content)
  toast.info(`${title} copied to clipboard`)
}
